import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosResponseTransformer,
} from "axios";
import AsyncLocalStorage from "./AsyncLocalStorage";
// import { loginOut } from "../navigation/RootAuthProvider";

export const OK = "OK";

export type Response = {
  ok: boolean;
  status: Number;
  msg: string;
  data: any;
};
export default class Axios {
  // Here you can use your server URL

  private static readonly baseURL: string =
    process.env.REACT_APP_API_URL || "http://localhost:3000";

  private static async buildHeader(obj = {}) {
    // let token = await AsyncLocalStorage.getItem("userToken");
    // let refreshToken = await AsyncLocalStorage.getItem("userRefreshToken");
    const token =
      "WMJWT eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InplbndAaXZpZC5rciIsInVzZXJfaWQiOjE1NjYxLCJkZXZpY2VfdXVpZCI6IkQ4ODI5MTQ1LTExMTEtMjIyMi0zMzMzLTE4NzA3QzMwQkExMyIsImlhdCI6MTcwMTA3NTAyNiwiZXhwIjoxNzAxMDc1OTI2fQ.zKp0C8MEKjWCJ1qsq5SL62OXS-JSSSTnOd1qrAFdCY8";
    const refreshToken =
      "B0RKzSp2nx4hi0ybdM2jjBYcnUG7IPsJ4GvmLueSBfWM0lOhUZjAMBRQYkfOLAko52HP8u3JM4Xuk5QvulzF9sVqygqeXyrg3FxRtRpqhhEhhNXYBud9lpRL9uSZlADN";

    const apiKey =
      "fcb128fe131d89cac5cafea86ceb1a7d87c0638100ec541acf3d6b8b2eb7d11b45f0fb67f4af9344e97e1ffc0af4faca";

    const header: any = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token,
      "refresh-token": refreshToken,
      "api-key": apiKey,
    };

    Object.assign(header, obj);

    return header;
  }

  private static transformResponse(
    input: string
  ): AxiosResponseTransformer | AxiosResponseTransformer[] {
    return JSON.parse(input);
  }

  public static async client(header = {}): Promise<AxiosInstance> {
    // cancelToken and source declaration
    const cancelTokenSource = axios.CancelToken.source();
    let headers: any = await this.buildHeader(header);
    // axios client config
    const config: any = {
      baseURL: this.baseURL,
      cancelToken: cancelTokenSource.token,
      headers,
      timeout: 20000,
    };

    // axios client response transformer
    config.transformResponse = [
      (data: unknown) => {
        return data && typeof data === "string"
          ? this.transformResponse(data)
          : data;
      },
    ];
    const axiosInstance = axios.create(config);
    axiosInstance.interceptors.response.use(
      async (response) => {
        let token = response.headers["refreshed-token"];
        if (token) {
          await AsyncLocalStorage.setItem("token", token);
          //console.log("newtoken", token);
        }
        return response;
      },
      (err) => {
        return Promise.reject(err);
      }
    );
    // create axios client
    return axiosInstance;
  }

  /**
   *
   * @param url
   * @returns
   */
  public static async get<T>(
    url: string,
    params?: any
  ): Promise<AxiosResponse> {
    try {
      let result: any = await (await this.client()).get<T>(url, params);

      return result;
    } catch (err) {
      let oErr: any = err;
      const { response } = oErr;

      console.log("response", response);
      if (response && response.data) {
        //let oResponse = response.data;
        if (response && response.status === 401) {
          // loginOut();
        }
      }

      if (response) {
        return response;
      }
      return oErr;
    }
  }

  /**
   *
   * @param url
   * @param payload
   * @returns
   */
  public static async post<T>(
    url: string,
    data?: any,
    responseFunc?: (args?: any) => any
  ): Promise<AxiosResponse> {
    console.log("post url", url);
    //console.log('process.env', process.env);

    var fResponse: any = {
      onDownloadProgress: (progressEvent: any): void => {},
    };

    try {
      let result = (await (
        await this.client()
      ).post<T>(url, data, fResponse)) as any;
      return result;
    } catch (err) {
      let oErr: any = err;
      const { response } = oErr;

      console.log("response", response);
      if (response && response.data) {
        //let oResponse = response.data;
        if (response && response.status === 401) {
          // loginOut();
        }
      }

      if (response) {
        return response;
      }
      if (oErr.code === "ECONNABORTED") {
      }
      return oErr;
    }
  }

  /**
   *
   * @param url
   * @param payload
   * @returns
   */
  public static async multipartPost<T>(
    url: string,
    data?: any,
    store_id?: number,
    responseFunc?: (args?: any) => any
  ): Promise<AxiosResponse> {
    var fResponse: any = {
      onDownloadProgress: (progressEvent: any): void => {},
    };

    try {
      let result = (await (
        await this.client({
          "Content-Type": "multipart/form-data",
          store_id: store_id,
        })
      ).post<T>(url, data, fResponse)) as any;
      return result;
    } catch (err) {
      let oErr: any = err;
      const { response } = oErr;
      if (response) {
        return response;
      }
      if (oErr.code === "ECONNABORTED") {
      }
      return oErr;
    }
  }

  public static async patch<T>(
    url: string,
    data?: any,
    responseFunc?: (args?: any) => any
  ): Promise<AxiosResponse> {
    try {
      let result = await (await this.client()).patch<T>(url, data);
      return result;
    } catch (err) {
      let oErr: any = err;
      const { response } = oErr;
      if (response) {
        return response;
      }
      return oErr;
    }
  }

  public static async put<T>(
    url: string,
    data?: any,
    responseFunc?: (args?: any) => any
  ): Promise<AxiosResponse> {
    try {
      let result = await (await this.client()).put<T>(url, data);
      return result;
    } catch (err) {
      let oErr: any = err;
      const { response } = oErr;
      if (response) {
        return response;
      }
      return oErr;
    }
  }

  public static async delete<T>(
    url: string,
    responseFunc?: (args?: any) => any
  ): Promise<AxiosResponse> {
    try {
      let result = await (await this.client()).delete<T>(url);
      return result;
    } catch (err) {
      let oErr: any = err;
      const { response } = oErr;
      if (response) {
        return response;
      }
      return oErr;
    }
  }
}
